<template>
  <rest-page :fetch-endpoint="null">
    <rest-form
      ref="form"
      :save-endpoint="saveEndpoint"
      :after-save="afterSave"
      :model="model"
      :rules="rules"
      @on-error="onError"
    >
      <rest-form-item
        :label="$t('PublishTemplateForm_Template_Name_Label')"
        prop="title"
      >
        <el-input v-model="model.title" maxlength="255" show-word-limit />
      </rest-form-item>
      <rest-form-item
        :label="$t('PublishTemplateForm_Template_Description_Label')"
        prop="description"
      >
        <el-input
          type="textarea"
          :rows="3"
          v-model="model.description"
          resize="none"
          maxlength="255"
          show-word-limit
        />
      </rest-form-item>
      <rest-form-item
        :label="$t('PublishTemplateForm_Template_Vertical_Label')"
        prop="verticals"
      >
        <el-select
          v-model="model.verticals"
          filterable
          multiple
          clearable
          :placeholder="$t('PublishTemplateForm_Select_Verticals_Placeholder')"
        >
          <el-option
            v-for="(value, name, index) in verticals"
            :key="index"
            :value="value"
            :label="$t(verticalLabelEnum[name])"
          />
        </el-select>
      </rest-form-item>
      <rest-form-item
        :label="$t('PublishTemplateForm_Template_Dependency_Label')"
        prop="dependencies"
      >
        <el-select
          v-model="model.dependencies"
          filterable
          multiple
          clearable
          :placeholder="
            $t('PublishTemplateForm_Select_Dependencies_Placeholder')
          "
        >
          <el-option-group
            v-for="(groupValue, groupLabel, index) in dependencies"
            :key="index"
            :label="groupLabel"
          >
            <el-option
              v-for="(optionValue, optionLabel, optionIndex) in groupValue"
              :key="optionIndex"
              :value="optionValue"
              :label="$t(optionLabel)"
            />
          </el-option-group>
        </el-select>
      </rest-form-item>
    </rest-form>
  </rest-page>
</template>

<script>
import RestApi from '@/core/services/RestApi'
import RestForm from '@/common/components/rest/RestForm'
import RestPage from '@/common/components/rest/RestPage'
import RestFormItem from '@/common/components/rest/RestFormItem'
import { projectRoute } from '@/core/helpers'
import { verticalLabelEnum } from '@/modules/campaigns/enum/VerticalLabelEnum'
import {
  ChannelDependencyLabel,
  FeatureDependencyLabel
} from '@/modules/campaigns/enum/CampaignTemplateDependencyLabelEnum'
import { campaignTypeEnum } from '@/modules/campaigns/enum/CampaignTypeEnum'
import { broadcastOptions } from '@/modules/campaign-manage/enum/BroadcastOptions'

export default {
  name: 'PublishTemplateForm',
  components: { RestFormItem, RestPage, RestForm },
  props: {
    campaignModel: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      model: {
        title: '',
        description: '',
        verticals: [],
        dependencies: []
      },
      verticals: {},
      verticalLabelEnum,
      dependencies: {
        Channels: ChannelDependencyLabel,
        Features: FeatureDependencyLabel
      }
    }
  },
  mounted() {
    let campaignFlags = ['promotion', 'seed_list_enabled', 'throttling']
    this.model.dependencies = this.model.dependencies.concat(
      this.campaignModel.channels
    )
    for (let flag of campaignFlags) {
      if (this.campaignModel[flag]) {
        this.model.dependencies.push(flag)
      }
    }

    if (this.campaignModel.type === campaignTypeEnum.TYPE_WORKFLOW) {
      this.model.dependencies.push('maxautomation')
    }
    if (this.campaignModel.broadcast === broadcastOptions.ROLLING_SEGMENT) {
      this.model.dependencies.push('rolling_segments')
    }
    RestApi.get('verticals').then(({ data }) => {
      this.verticals = {
        ...data
      }
    })
  },
  computed: {
    rules() {
      return {
        title: {
          required: true,
          message: this.$t('RestForm_FieldIsRequired')
        },
        description: {
          required: true,
          message: this.$t('RestForm_FieldIsRequired')
        },
        verticals: {
          required: true,
          message: this.$t('RestForm_FieldIsRequired')
        },
        dependencies: {
          required: false
        }
      }
    },
    saveEndpoint() {
      return {
        method: 'post',
        url: `shared-campaign-templates?campaign_id=${this.campaignModel.id}&project_id=${this.$route.query.project_id}`
      }
    }
  },
  methods: {
    onError() {
      document.querySelector('.v-modal').remove()
    },
    validate() {
      return this.$refs['form'].validate()
    },
    save() {
      this.validate()
        .then(valid => {
          if (valid) {
            this.$confirm(
              this.$t('PublishTemplateForm_ConfirmationMessage'),
              this.$t('PublishTemplateForm_ConfirmationTitle'),
              {
                confirmButtonText: this.$t(
                  'PublishTemplateForm_ConfirmationBtnText'
                ),
                cancelButtonText: this.$t('PublishTemplateForm_CancelBtnText'),
                showClose: false,
                center: true
              }
            )
              .then(() => {
                this.$refs['form'].save()
              })
              .catch(() => {
                this.$parent.handleClose()
              })
          }
        })
        .catch(() => {})
    },
    resetForm() {
      this.model.title = ''
      this.model.description = ''
      this.model.verticals = []
      this.model.dependencies = []
    },
    afterSave() {
      this.$router.push(
        projectRoute({
          name: 'PreMadeTemplatesTab'
        })
      )
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/campaigns/components/PublishTemplateForm.vue